import { AxiosInstance } from "../../axios/axiosInstance";
import { apiRoutes } from "../../utils/ApiRoutes";

export interface IEditWidgetData {
  widget_id: string;
  name: string;
  map_height: number;
  map_zoom: number;
  show_customer_name: boolean;
  show_address_disclaimer: boolean;
  show_moment_dates: boolean;
  obfuscate_review_type: string;
  custom_author_name: string;
  moments_per_page: number;
  background_color: string;
  widget_layout: string;
  moment_list_layout: string;
  moment_card_media_position: string;
  date_format: string;
  map_marker_icon: string;
  map_marker_icon_url: string;
  map_marker_color: string;
  no_data_image: string;
  card_background_type: string;
  theme_type: string;
  theme_name: string;
  moment_card_font_size: number;
  gradient_rotation: number;
  gradient_first_color: string;
  gradient_first_stop: number;
  gradient_second_color: string;
  gradient_second_stop: number;
  text_color: string;
  buisness_color: string;
  category_color: string;
  category_bg_color: string;
  border_color: string;
}

export const addWidgetApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.addWidget, payload);
  return response;
};

export const editWidgetApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editWidget, payload);
  return response;
};

export const getWidgetApi = async (business_id: string) => {
  const response = await AxiosInstance.post(apiRoutes?.getWidgets, { business_id });
  return response;
};

export const deleteWidgetApi = async (widget_id: string) => {
  const response = await AxiosInstance.delete(
    `${apiRoutes?.deleteWidget}/${widget_id}`
  );
  return response;
};

export const copyWidgetApi = async (widget_id: string) => {
  const response = await AxiosInstance.post(apiRoutes?.copyWidget, {
    widget_id,
  });
  return response;
};

export const getWidgetDataApi = async (payload: {
  business_id: string;
  widget_id?: string;
}) => {
  const response = await AxiosInstance.post(apiRoutes?.getWidgetData, payload);
  return response;
};

export const getWidgetPinsApi = async (payload: {
  business_id: string;
  widget_id: string;
  bbox?: { sw: [number, number]; ne: [number, number] };
  zoom?: number;
  is_filter_by_category?: boolean;
  selected_category?: string[];
  is_filter_by_locality?: boolean;
  selected_localities?: string[];
}) => {
  const response = await AxiosInstance.post(apiRoutes?.getWidgetPins, payload);
  return response;
};

export const getWidgetListApi = async (payload: {
  business_id: string;
  widget_id: string;
  cursor?: string;
  limit?: number;
  is_filter_by_category?: boolean;
  selected_category?: string[];
  is_filter_by_locality?: boolean;
  selected_localities?: string[];
}) => {
  const response = await AxiosInstance.post(apiRoutes?.getWidgetList, payload);
  return response;
};

export const getWidgetDetailApi = async (payload: {
  business_id: string;
  widget_id: string;
  post_id: string;
}) => {
  const response = await AxiosInstance.post(apiRoutes?.getWidgetDetail, payload);
  return response;
};

export const getWidgetLocalitiesApi = async (payload: {
  business_id: string;
  widget_id?: string;
  is_filter_by_category?: boolean;
  selected_category?: string[];
}) => {
  const response = await AxiosInstance.post(apiRoutes?.getWidgetLocalities, payload);
  return response;
};

export const editMapWidgetApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.editMapWidget, payload);
  return response;
};

export const setwidgetpreferenceApi = async (payload: any) => {
  const response = await AxiosInstance.post(apiRoutes?.setwidgetpreference, 
    payload,
  );
  return response;
};

export interface ISendWidgetInstallEmailPayload {
  widget_id: string;
  business_id: string;
  to: string;
}

export const sendWidgetInstallEmailApi = async (
  payload: ISendWidgetInstallEmailPayload
) => {
  const response = await AxiosInstance.post(
    apiRoutes?.sendWidgetInstallEmail,
    payload
  );
  return response;
};
